import Vue from "vue";
import { Company } from "@/models";

export type GlobalDataModule = {
  companies: Array<Company>;
  companyName?: string;
  companyId?: string;
  loading: boolean;
  checked: boolean;
  scrollTop: number;
  setCompany: (company?: Company) => void;
};

export const registerGlobalData = () => {
  type GlobalData = {
    companies: Array<Company>;
    companyName?: string;
    companyId?: string;
    loading: boolean;
    checked: boolean;
    scrollTop: number;
  };
  Vue.prototype.$globalData = new Vue({
    data(): GlobalData {
      return {
        companies: [],
        companyName: undefined,
        companyId: undefined,
        loading: false,
        checked: false,
        scrollTop: 0,
      };
    },

    methods: {
      setCompany(company?: Company) {
        this.companyId = company?.id;
        this.companyName = company?.name;
        this.$gtag.set({
            'dimension1': company?.name
        });
      },
    },
  });
};
